import Axios from 'axios'
import React, { Component } from 'react'
import Topbar from '../../Common/Topbar'
import Spinner from '../../Components/Spinner'
import config from '../../Shared/config'
import ListingCard from './ListingCard'
import './OnlineListings.scss'

export default class OnlineListings extends Component {

    constructor(props) {
        super(props)

        this.state = {
            listingsArray: [],
            listingsFetching: false,
            listingsFetched: false
        }
    }

    componentDidMount() {
        const id = this.props?.match?.params?.teacher_id
        this.getListingsByTeacherId(id).then(res => {

            this.setState({
                listingsArray: res,
                listingsFetching: false,
                listingsFetched: true
            })

        }).catch(err => {
            console.error(err)
            this.setState({
                listingsArray: [],
                listingsFetching: false,
                listingsFetched: false
            })
        })
    }

    getListingsByTeacherId = async (id) => {
        this.setState({
            listingsFetching: true,
            listingsFetched: false
        })
        const url = `${config.apiUrl}/Listing/getAllByTeacher?id=${id}`;
        return Axios.get(url).then(res => {
            if (!res?.data?.error) {
                return res.data.data
            }
        })
    }

    render() {

        const { listingsArray, listingsFetching, listingsFetched, nextPageNumber } = this.state

        return (
            <div className='alllistings'>
                <Topbar type={'fixedover'} theme={'solid'} />
                <div className="below-topbar-content">
                    <div className='listings'>

                        <h1>Listing Details <img alt='features' src={'https://www.flaticon.com/svg/static/icons/svg/2436/2436654.svg'}></img></h1>
                        {
                            listingsFetching ? (
                                <>
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                    <Spinner />
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                </>
                            ) : (
                                    listingsFetched ? (
                                        <>
                                            <div className="cards">
                                                {
                                                    listingsArray.map((item, idx) => {
                                                        return <ListingCard key={idx} item={item} />;
                                                        // return <Link to={`/online-listings/${item._id}`}><TeacherCard teacher={item} /></Link>
                                                    })
                                                }
                                            </div>
                                        </>
                                    ) : null
                                )
                        }
                        {
                            !nextPageNumber ? (
                                <div className="result-end">
                                    Oh no! We ran out of suggestions. <span role='img' aria-label='astonished'>😟</span>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}
